import React, { useState } from 'react';
import { Button, Grid, Paper, TextField, Typography } from '@mui/material';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import toast from 'react-hot-toast';

import { SpecialService, SpecialServicesService } from 'us-web-services';
import DisplayService from '../../util/DisplayService';
import PageStyles from '../../styles/PageStyles';

function SpecialServicesAdd(props: RouteComponentProps) {
  const { history } = props;
  const [name, setName] = useState('');
  const [code, setCode] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { classes } = PageStyles();

  const addSpecialService = async () => {
    if (!name.trim()) {
      toast.error('Name is required');

      return;
    }

    setIsSubmitting(true);

    const serviceData: SpecialService = {
      name: name.trim(),
      code: code.trim() || undefined,
      disabled: null,
    };

    try {
      await SpecialServicesService.create(serviceData);
      toast.success('Special service successfully added');
      history.push('/special-services');
    } catch (error) {
      const displayedError = DisplayService.getErrorResponse(
        error,
        'There was an error adding the special service.',
      );

      toast.error(displayedError.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const cancel = () => {
    history.push('/special-services');
  };

  const updateName = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const updateCode = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCode(event.target.value);
  };

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' && !isSubmitting) {
      addSpecialService();
    }
  };

  return (
    <Paper className={classes.paper}>
      <Typography variant='h5' gutterBottom>
        Add Special Service
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            id='special-service-name'
            label='Name'
            variant='outlined'
            fullWidth
            required
            value={name}
            onChange={updateName}
            onKeyPress={handleKeyPress}
            helperText='The display name for this special service'
            error={!name.trim() && name.length > 0}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id='special-service-code'
            label='Code'
            variant='outlined'
            fullWidth
            value={code}
            onChange={updateCode}
            onKeyPress={handleKeyPress}
            helperText='Optional code identifier for this special service (e.g., drivingSitterCar)'
          />
        </Grid>
      </Grid>
      <div className={classes.buttons} style={{ marginTop: 20 }}>
        <Button
          id='cancel'
          variant='contained'
          color='secondary'
          onClick={cancel}
          disabled={isSubmitting}
          style={{ marginRight: 10 }}
        >
          Cancel
        </Button>
        <Button
          id='add-special-service-button'
          variant='contained'
          color='primary'
          onClick={addSpecialService}
          disabled={isSubmitting || !name.trim()}
        >
          {isSubmitting ? 'Adding...' : 'Add Special Service'}
        </Button>
      </div>
    </Paper>
  );
}

export default withRouter(SpecialServicesAdd);
